module.exports = __webpack_public_path__ + "img/integrar_tienda_button.43d91223.png";